import { gql } from '@apollo/client';

export const GET_ZUSCHLAGSGRUPPEN_BY_STANDORT = gql`
  query Mitarbeiter_GetZuschlagsgruppen($standortId: String!) {
    zuschlagsgruppenByIdStandorte(standortId: $standortId) {
      __typename
      ... on ZuschlagsgruppeByIdStandort {
        zuschlagsgruppen {
          id
          name
        }
      }
      ... on ZuschlagsgruppeError {
        message
        type
      }
    }
  }
`;
